import Vue from 'vue'

const allFeatures = ['mega', 'huckepack', 'coil', 'liftingroof', 'taillift', 'link', 'openingside', 'doublecompartment', 'doublestock', 'drawbar', 'long']
const trailerInfo = {
    categoryNames: {
        curtain: 'Curtain',
        reefer: 'Reefer',
        box: 'Box',
        movingfloor: 'Moving Floor',
        dolly: 'Dolly',
        flatbed: 'Flatbed',
        container: 'Container Chassis',
    },
    categoryFeatures: {
        curtain: allFeatures,
        reefer: allFeatures,
        box: allFeatures,
        movingfloor: allFeatures,
        dolly: allFeatures,
        flatbed: allFeatures,
        container: allFeatures,
        drawbar: allFeatures,
        /*
        curtain: ['mega', 'huckepack', 'coil', 'liftingroof', 'taillift', 'link'],
        reefer: ['huckepack', 'openingside', 'doublecompartment', 'doublestock', 'link'],
        box: ['huckepack', 'openingside', 'doublecompartment', 'doublestock', 'link'],
        movingfloor: ['openingside'],
        dolly: [],
        flatbed: [],
        container: [],
        drawbar: [],
        */
    },
    featureNames: {
        mega: 'Mega',
        huckepack: 'Huckepack',
        coil: 'Coil',
        liftingroof: 'Lifting Roof',
        taillift: 'Tail lift',
        link: 'Link',
        openingside: 'Opening Side',
        doublecompartment: 'Double Compartment (DC)',
        doublestock: 'Double Stock (DS)',
        drawbar: 'Drawbar',
        nordic: 'Nordic',
        city: 'City',
        lift: 'Lift',
        adr: 'Adr',
        steeringaxle: 'Steering Axle',
        liftingaxle: 'Lifting Axle',
        extendable: 'Extendable',
        gooseneck: 'Gooseneck',
        multifunctional: 'Multi Functional',
        coolingunit: 'Cooling Unit',
        fixed: 'Fixed',
        hydraulic: 'Hydraulic',
        heatingunit: 'Heating Unit',
        curtainroof: 'Curtain Roof',
        long: 'Long',
    },
    categoryDescriptions: {
        curtain: 'Curtainside trailers are the most common and flexible choice for transportation of industrial goods.',
        reefer: 'Reefer trailers are the most common choice for transportation of goods sensitive to temperature.',
        box: 'Box trailers are the most common choice for transportation of high value and sensitive goods.',
        movingfloor: 'Moving floor trailers are the most common choice for transportation of garbage, scrap, agricultural products, wood, glass and peat.',
        dolly: 'Dollies are the most common choice for cost-effective 25.25 m traffic.',
        flatbed: 'Flatbed trailers are the most common choice for transportation of special goods.',
        container: 'Container chassis are the most common choice for container movement.',
    }
}

Vue.mixin({
    methods: {
        trailerCategoryDescription(category) {
            return trailerInfo.categoryDescriptions[category]
        },
        trailerAvailableNow(trailer) {
            return new Date(trailer.availableFrom) < new Date()
        },
        trailerGetBadges(trailer) {
            const features = trailer.details.features ? trailer.details.features : []
            return features.map(feature => this.trailerFeatureName(feature))
        },
        trailerCategoryName(category) {
            return trailerInfo.categoryNames[category] ? trailerInfo.categoryNames[category] : category
        },
        trailerFeatureName(feature) {
            return trailerInfo.featureNames[feature] ? trailerInfo.featureNames[feature] : feature
        },
        trailerCategoryFeatures(category) {
            return trailerInfo.categoryFeatures[category] ? trailerInfo.categoryFeatures[category] : []
        },
        trailerTypeImageUrl(trailer) {
            const features = trailer.details.features ? trailer.details.features : []
            if (trailer.details.category == 'curtain') {
                if (features.includes('coil')) return require('@/assets/img/type_curtain_coil.jpg')
                if (features.includes('huckepack')) return require('@/assets/img/type_curtain_huckepack.jpg')
                if (features.includes('mega')) return require('@/assets/img/type_curtain_mega.jpg')
                if (features.includes('nordic')) return require('@/assets/img/type_curtain_nordic.jpg')
                if (features.includes('link')) return require('@/assets/img/type_curtain_link.jpg')
                if (features.includes('city')) return require('@/assets/img/type_curtain_city.jpg')
                return require('@/assets/img/type_curtain.jpg')
            }
            if (trailer.details.category == 'reefer') {
                if (features.includes('link')) return require('@/assets/img/type_reefer_link.jpg')
                return require('@/assets/img/type_reefer.jpg')
            }
            if (trailer.details.category == 'box') {
                if (features.includes('link')) return require('@/assets/img/type_box_link.jpg')
                if (features.includes('openingside')) return require('@/assets/img/type_box_opening-side.jpg')
                if (features.includes('city')) return require('@/assets/img/type_box_city.jpg')
                return require('@/assets/img/type_box.jpg')
            }
            if (trailer.details.category == 'movingfloor') {
                if (features.includes('openingside')) return require('@/assets/img/type_moving-floor_opening-side.jpg')
                if (features.includes('link')) return require('@/assets/img/type_moving-floor_link.png')
                return require('@/assets/img/type_moving-floor.jpg')
            }
            if (trailer.details.category == 'dolly') {
                return require('@/assets/img/type_dolly.jpg')
            }
            if (trailer.details.category == 'flatbed') {
                return require('@/assets/img/type_flatbed.jpg')
            }
            if (trailer.details.category == 'container') {
                if (features.includes('gooseneck')) return require('@/assets/img/type_container-chassis_gooseneck.jpg')
                if (features.includes('link')) return require('@/assets/img/type_container-chassis_link.jpg')
                return require('@/assets/img/type_container-chassis.jpg')
            }
            return require('@/assets/img/type_curtain.jpg')
        }
    }
})
